import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('returnDomains', {
  customKeys: {
    list: 'domains',
  },
  customEndpoints: {
    list: '/domains/financing_return_rules',
  },
});
